<template>
  <div style="display: flex; justify-content: center;">
    <div style="width: 1300px;">
      <label>Sana {{ selectShablonJson.value119 }}</label>
      <h3 class="sarlovha-style">
        Shifokorning bo'limdagi ko'ruvi
      </h3>
      <label class="multiline-text"
        ><b>Bemorning shifoxonaga kelgan vaqtidagi shikoyati:</b>
        {{ selectShablonJson.value1 }}</label
      >
      <br />
      <label class="multiline-text"
        ><b>Anamnesis morbi (ushbu kasallik tarixi):</b>
        {{ selectShablonJson.value2 }}</label
      >
      <h3 class="sarlovha-style">Epidemiologik anamnez</h3>
      <label>
        {{ selectShablonJson.value3 }} yuqumli kasalliklar
        {{ selectShablonJson.value4 }}</label
      >
      <label
        >bilan og'rigan bemorlar (kasallik inkubatsion davrini hisobga olgan
        holda) bilan muomalada bo'lganmi.</label
      >
      <label>Muloqotda bo'lgan vaqti: {{ selectShablonJson.value5 }}</label>
      <label>dan {{ selectShablonJson.value6 }} gacha</label>
      <label
        >Haqiqiy kasallik boshlanishidan 1-hafta - 2 oy avval axoli yashash
        joyidan chetda bo'lganmi {{ selectShablonJson.value7 }}
        {{ selectShablonJson.value8 }}</label
      >
      <label
        >Qanday yuqumli kasalliklar bilan og'rigan?
        {{ selectShablonJson.value9 }}</label
      >
      <div class="sarlovha">So'ngi 6 oy ichida:</div>
      <label
        >Statsionar yoki ambulator davolanishda bo'lganimi?
        {{ selectShablonJson.value10 }}</label
      >
      <label
        >Gemotransfuziya (Qon va uning komponentlari) o'tkazilganmi?
        {{ selectShablonJson.value11 }}</label
      >
      <label
        >Bemorga jarrohlik muolajalari o'tkazilganmi?
        {{ selectShablonJson.value12 }}</label
      >
      <label
        >Parenteral muolajalar (jumladan, igna bilan davolash) qabul qilinganmi?
        {{ selectShablonJson.value13 }}</label
      >
      <label
        >Maishiy xizmat turlaridan foydalanganmi (manikyur, pedikyur, tatuaj,
        ...) {{ selectShablonJson.value14 }}</label
      >
      <label>Xavfli omillar: {{ selectShablonJson.value15 }}</label>
      <label>Nasliy kasalliklar: {{ selectShablonJson.value16 }}</label>
      <label class="multiline-text"
        >Anamnesis vitae (bemorning hayot tarixi, kechirgan kasalliklari):
        {{ selectShablonJson.value17 }}</label
      >
      <label>O'tkazgan operatsiyalari: {{ selectShablonJson.value18 }}</label>
      <label>Ishlaydigan kasbi: {{ selectShablonJson.value19 }}</label>
      <label>Ovqatlanish tartibi: {{ selectShablonJson.value20 }}</label>
      <label>Moddiy-maishiy sharoiti: {{ selectShablonJson.value21 }}</label>
      <label>Salbiy odatlari: {{ selectShablonJson.value22 }}</label>
      <label
        >Alkagol ichimliklar istemoli: {{ selectShablonJson.value23 }}</label
      >
      <label>Oilaviy ahvoli: {{ selectShablonJson.value24 }}</label>
      <label
        >Oxirgi 6 oy ichida qabul qilgan muolajalari:
        {{ selectShablonJson.value25 }}</label
      >
      <label
        >Dori darmon va oziq ovqatlarga allergiyasi:
        {{ selectShablonJson.value26 }}</label
      >
      <label>Ovqatlanishi: {{ selectShablonJson.value27 }}</label>

      <h3 class="sarlovha-style">Umumiy ahvoli (Status preasets objektivus)</h3>
      <label class="multiline-text"
        >Umumiy axvoli {{ selectShablonJson.value28 }}</label
      >
      <label>Tana harorati {{ selectShablonJson.value29 }}</label>
      <label>Bo'yi(cm) {{ selectShablonJson.value30 }}</label>
      <label>Vazni(kg) {{ selectShablonJson.value31 }}</label>
      <label
        >Tana vazni indexsi (kg/cm^2) {{ selectShablonJson.value32 }}</label
      >
      <label>Hushi {{ selectShablonJson.value33 }}</label>
      <label
        >Teri va qornidagi shilliq qavatlarning holati
        {{ selectShablonJson.value34 }}</label
      >
      <label>Ko'z olmasining oq qismi {{ selectShablonJson.value35 }}</label>
      <label>Qalqonsimon bez holati {{ selectShablonJson.value36 }}</label>
      <label>Suyak-mushak tizimi: {{ selectShablonJson.value37 }}</label>
      <label
        >Periferik limfa tugunlari holati:
        {{ selectShablonJson.value38 }}</label
      >
      <h3 class="sarlovha-style">Nafas olish tizimi</h3>
      <label>Nafas olish {{ selectShablonJson.value39 }}</label>
      <label>NOS {{ selectShablonJson.value40 }}</label>
      <label>minutiga</label>
      <label
        >Ko'krak qafasining tuzilishi {{ selectShablonJson.value41 }}</label
      >
      <label>Pal'patsiyada {{ selectShablonJson.value42 }}</label>
      <label>Perkutor {{ selectShablonJson.value43 }}</label>
      <label>Pastki chegarasi D {{ selectShablonJson.value44 }}</label>
      <label>k/o {{ selectShablonJson.value45 }}</label>
      <label>k/o</label>
      <label>Auskultatsiyada {{ selectShablonJson.value46 }}</label>
      <label>Uzatiladi {{ selectShablonJson.value47 }}</label>
      <label>Xirillashlar {{ selectShablonJson.value48 }}</label>
      <label>Krepitatsiya {{ selectShablonJson.value49 }}</label>
      <label>Plevra ishqalanish shovqin {{ selectShablonJson.value50 }}</label>
      <h3 class="sarlovha-style">Yurak qon tomir tizimi</h3>
      <div class="sarlovha">Ko'krak qafasidagi o'zgarishlar:</div>
      <label
        >1. Ko'krak qafasidagi og'riq, og'riq yoki noxushlik sezasizmi?
        {{ selectShablonJson.value51 }}</label
      >
      <label
        >2. Bu og'riq tez yoki tepalikka qarab yurganda paydo boladimi?
        {{ selectShablonJson.value52 }}</label
      >
      <label
        >3. Agarda og'riq yurib ketayotganingizda paydo bo'sa nima qilasiz?
        {{ selectShablonJson.value53 }}</label
      >
      <label
        >4. To'xtasangiz og'riq nima bo'ladi?
        {{ selectShablonJson.value54 }}</label
      >
      <label>5. Qanchalik tez vaqtda? {{ selectShablonJson.value55 }}</label>
      <div class="sarlovha">
        Yurak o'ynog'i: {{ selectShablonJson.value56 }}
      </div>
      <label>Paydo bolish sharoiti {{ selectShablonJson.value57 }}</label>
      <label>To'xtash sharoiti {{ selectShablonJson.value58 }}</label>
      <div class="sarlovha">Xansirash: {{ selectShablonJson.value59 }}</div>
      <label>Paydo bolish sharoiti {{ selectShablonJson.value60 }}</label>
      <label>To'xtash sharoiti {{ selectShablonJson.value61 }}</label>
      <label>Qancha vaqtdan beri bor {{ selectShablonJson.value62 }}</label>
      <div class="sarlovha">Oyoq og'rig'i: {{ selectShablonJson.value63 }}</div>
      <label
        >Boldirda og'riq paydo bo'lishi {{ selectShablonJson.value64 }}</label
      >
      <label
        >Agar yurganda bo'lsa qancha vaqt davom etadi
        {{ selectShablonJson.value65 }}</label
      >
      <label>Qanday holatda o'tadi {{ selectShablonJson.value66 }}</label>
      <div class="sarlovha">Shish {{ selectShablonJson.value67 }}</div>
      <label>Joylari {{ selectShablonJson.value68 }}</label>
      <label>Qancha vaqtlradan beri bor {{ selectShablonJson.value69 }}</label>
      <label>Qaysi vaqtda paydo bo'ladi {{ selectShablonJson.value70 }}</label>
      <label>Nima yordam beradi {{ selectShablonJson.value71 }}</label>
      <div class="sarlovha">
        Vazin o'zgarishi {{ selectShablonJson.value72 }}
      </div>
      <label>Qancha miqdorda {{ selectShablonJson.value73 }}</label>
      <label>kg, qancha vaqtda {{ selectShablonJson.value74 }}</label>
      <label
        >Arterial qon bosimi (mm. cim. ust):
        {{ selectShablonJson.value75 }}</label
      >
      <label>Ritmi: {{ selectShablonJson.value76 }}</label>
      <label
        >Puls kattaligi (to'liqligi va tarangligi):
        {{ selectShablonJson.value77 }}</label
      >
      <label>Fo'rmasi: selectShablonJson.value78</label>

      <label>Yurak bukri: {{ selectShablonJson.value79 }}</label>
      <label>2. Tomirlarining pulsatsiyasi:</label>
      <label>bo'yin Ch {{ selectShablonJson.value80 }}</label>
      <label>O' {{ selectShablonJson.value81 }}</label>
      <label>, qo'l Ch {{ selectShablonJson.value82 }}</label>
      <label>O' {{ selectShablonJson.value83 }}</label>
      <label>, oyoq Ch {{ selectShablonJson.value84 }}</label>
      <label>O' {{ selectShablonJson.value85 }}</label>
      <label
        >Venalarning varikoz kengayishi tanada va qo'l-oyoqlarda:
        {{ selectShablonJson.value87 }}</label
      >
      <h3 class="sarlovha-style left">Palpalatsiya</h3>
      <label
        >1. Yurak cho'qqisining turtkisi {{ selectShablonJson.value87 }}</label
      >
      <label
        >2. "Mushuk hirrillashi" (3-5 qovurg'a oralig'i chapda)
        {{ selectShablonJson.value88 }}</label
      >
      <label>3. Tetrosternal pulsatsiya {{ selectShablonJson.value89 }}</label>
      <label>3. Epigastral pulsatsiya {{ selectShablonJson.value90 }}</label>
      <h3 class="sarlovha-style left">Perkussiya</h3>
      <label>Yurakning nisbiy bug'iqligi</label>
      <label>Chegarasi. Chap {{ selectShablonJson.value91 }}</label>
      <label>O'ng {{ selectShablonJson.value92 }}</label>
      <label>Yuqori {{ selectShablonJson.value93 }}</label>

      <h3 class="sarlovha-style left">Auskultatsiya</h3>
      <label>Yurak tonlari:</label>
      <label>I ton {{ selectShablonJson.value94 }}</label>
      <br />
      <label>II ton {{ selectShablonJson.value95 }}</label>
      <h3 class="sarlovha-style left">Yurak shovqinlari</h3>
      <label>Cisotlik:</label>
      <label>Yurak cho'qqisida {{ selectShablonJson.value96 }}</label>
      <label>aorta {{ selectShablonJson.value97 }}</label>
      <label>o'pka arteriasida {{ selectShablonJson.value98 }}</label>
      <label>Diastolik:</label>
      <label>Yurak cho'qqisida {{ selectShablonJson.value99 }}</label>
      <label>aorta {{ selectShablonJson.value100 }}</label>
      <label>o'pka arteriasida {{ selectShablonJson.value101 }}</label>
      <label>Yurakdan tashqari: {{ selectShablonJson.value102 }}</label>

      <h3 class="sarlovha-style">Hazm qilish tizimi</h3>
      <div class="display-flex">
        <div style="width: 50%;">
          <label>Tili {{ selectShablonJson.value103 }}</label>
          <label>Qorin terisi {{ selectShablonJson.value104 }}</label>
          <label>Jigar {{ selectShablonJson.value105 }}</label>
        </div>

        <div style="width: 50%;">
          <label>Bodomsimon bez {{ selectShablonJson.value106 }}</label>
          <label>Qorin {{ selectShablonJson.value107 }}</label>
          <label
            >Kurlov bo'yincha o'lchami {{ selectShablonJson.value108 }}</label
          >
        </div>
      </div>
      <label>Taloq {{ selectShablonJson.value109 }}</label>
      <label>Astsit {{ selectShablonJson.value110 }}</label>
      <label>Shetkin simptomi {{ selectShablonJson.value111 }}</label>
      <label>Ich kelishi {{ selectShablonJson.value112 }}</label>

      <h3 class="sarlovha-style">Siydik ajralish tizimi</h3>
      <div class="display-flex">
        <div style="width: 50%;">
          <label>Dizurik o'zgarish {{ selectShablonJson.value113 }}</label>
          <label>Sutkalik diures {{ selectShablonJson.value114 }}</label>
          <label>Siydik ajratish {{ selectShablonJson.value115 }}</label>
        </div>

        <div style="width: 50%;">
          <label>Siydik rangi {{ selectShablonJson.value116 }}</label>
          <label>Turtki belgisi {{ selectShablonJson.value117 }}</label>
          <label>Tiniqligi {{ selectShablonJson.value118 }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectShablonJson: {},
      data: {}
    };
  },
  filters: {
    dateFormat: function(date) {
      if (date) {
        return moment.unix(date).format("DD.MM.YYYY");
      } else {
        return "";
      }
    }
  },
  created: function() {
    this.data = JSON.parse(localStorage.getItem("StatDoctor"));
    this.selectShablonJson = JSON.parse(this.data.value.toString());
  },
  mounted() {
    localStorage.removeItem("StatDoctor");
    window.print();
    setTimeout(() => {
      //   this.$router.push({ path: "/user" });
      window.close();
    }, 3000);
  }
};
</script>

<style lang="scss">
.multiline-text {
  white-space: pre-line;
}
.sarlovha {
  font-family: "Times New Roman";
  font-size: 14pt;
  font-weight: 600;
  font-style: oblique;
}
.sarlovha-style {
  margin-top: 10px;
  text-align: center;
  font-family: "Times New Roman";
}
.left {
  text-align: left;
}
label {
  font-family: "Times New Roman", Times, serif;
  // margin-top: 5px;
  font-size: 14pt;
  line-height: 14pt;
  // font-size: 13pt;
  font-weight: 500;
  margin-right: 5px;
}
.display-flex {
  display: flex;
}
</style>
